import * as React from "react";
import { useSearchParams } from "react-router-dom";
import { useTitle } from "../../utils/UseTitleUtils";
import MarketingHero from "components/marketing/MarketingHero";

interface EmailVerificationErrorProps {}

const ERRORS = {
  EMPTY: "Activation code cannot be empty",
  INVALID: "Activation code invalid",
  NOT_FOUND: "Activation code cannot be found",
  ALREADY_ACTIVE:
    "Activation has already been completed for this account.  Please check your account for the Confirmation email.",
};

const EmailVerificationError = (props: EmailVerificationErrorProps) => {
  const [params] = useSearchParams();
  useTitle("Activation failed");
  const error = params.get("error");

  return (
    <div className="marketing-page marketing-page--status">
      <main className="marketing-page__main">
        <MarketingHero
          title={error === "ALREADY_ACTIVE" ? "Already Activated" : "Activation Failed"}
        />

        <section className="marketing-page__section">
          <div className="marketing-page__status-card">
            <div
              className={`marketing-page__status-icon${
                error === "ALREADY_ACTIVE"
                  ? " marketing-page__status-icon--success"
                  : " marketing-page__status-icon--error"
              }`}
            >
              <img
                src={
                  error === "ALREADY_ACTIVE"
                    ? "/assets/svgs/user_tick.svg"
                    : "/assets/svgs/user_cancel.svg"
                }
                alt="activation status"
              />
            </div>
            <h1
              className={`marketing-page__status-title${
                error === "ALREADY_ACTIVE"
                  ? ""
                  : " marketing-page__status-title--error"
              }`}
            >
              {error === "ALREADY_ACTIVE"
                ? "Already activated"
                : "Activation failed!"}
            </h1>
            <div className="marketing-page__status-copy">
              {error === "ALREADY_ACTIVE" ? (
                <p>{ERRORS[error]}</p>
              ) : (
                <>
                  <p>
                    Your email has not been successfully confirmed. Please
                    contact support or try again later.
                  </p>
                  <p className="marketing-page__status-strong marketing-page__status-strong--error">
                    {ERRORS[error]}
                  </p>
                </>
              )}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default EmailVerificationError;
